<template>
  <div id="Home">
    <Topimage class="topbkColor"/>
    <WhatsPinPos class="WhatspinposBk"/>
    <HowPinPosWorks class="HowPinPosWorksBK"/>
    <TrustedSection class="TrustedBK"/>
    <div id="contactButton">
      <Contact class="ContactBK"/>
    </div>
  </div>
</template>

<script>
import Topimage from '@/components/TopImageSection.vue'
import WhatsPinPos from '@/components/Whatispinpos.vue'
import HowPinPosWorks from '@/components/Howpinposworks.vue'
import TrustedSection from '@/components/TrustedSection.vue'
import Contact from '@/components/Contact.vue'
export default {
  name: 'Pin Pos Home',
  components: {
    Topimage,
    WhatsPinPos,
    HowPinPosWorks,
    TrustedSection,
    Contact
  },
  methods: {
    // isMobile() {
    //     if( screen.width <= 768 ) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    // },
  }
}
</script>
<style scoped>
  .topbkColor {
    background-color: #FFFFFF;
  }
  .WhatspinposBk {
    background-color: #FFFFFF;
  }
  .HowPinPosWorksBK {
    background-color: #2D2D39;
  }
  .TrustedBK {
    background-color: #FFFFFF;
  }
  .ContactBK {
    background-color: #e6e4e4;
  }
</style>
